export function SQLInjectionUd() {
    const udemyCourses = [
      {
        title: "Unity Ud - Introduction to HTML Web Development",
        url: "https://www.udemy.com/course/intro-to-html-web-development/?couponCode=ST7MT110524"
      },
      {
        title: "HTML and CSS for Beginners - Build a Website & Launch ONLINE",
        url: "https://www.udemy.com/course/html-and-css-for-beginners-crash-course-learn-fast-easy/?couponCode=ST7MT110524"
      },
      {
        title: "Learn HTML and CSS in 7 Days | Web Developer Bootcamp",
        url: "https://www.udemy.com/course/learn-html-and-css-in-7-days-web-developer-bootcamp/?couponCode=ST7MT110524"
      },
      {
        title: "Learn HTML: Course For Beginners",
        url: "https://www.udemy.com/course/html-course-for-beginners/?couponCode=ST7MT110524"
      },
      {
        title: "HTML5: HTML Authoring Certification Course",
        url: "https://www.udemy.com/course/html5-authoring-certification/?couponCode=ST7MT110524"
      }
    ];
  
    return (
      <>
        <h1 className="html_ud_heading">
          These are the <strong style={{ textDecoration: 'underline', color: 'blue' }}>Top 5</strong> recommended Udemy courses that you can refer to with certifications.
        </h1>
  
        <h4 className="des_ud_html">
          1. Dive into the main concepts. <br />
          2. Animation explanations with real-world examples. <br />
          3. Important note clarification.
        </h4>
  
        {udemyCourses.map((course, index) => (
          <div key={index} className="container_html_ud_links">
            <p className="vid">{index + 1}. {course.title}
              <button 
                className="course-button"
                onClick={() => window.open(course.url, "_blank")}
                aria-label={`Go to ${course.title}`}
              >
                Click Me
              </button>
            </p>
          </div>
        ))}
      </>
    );
  }
  
  export default SQLInjectionUd;
  